<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appUploadTable
          alwaysShow="true"
          :class="!getUploadsForPP.length ? 'notUploaded' : ''"
        ></appUploadTable>
        <appPersonalizationButton
          v-show="getPersonalizationFullPage"
          v-if="!getUploadPersonalizationOneProduct"
        ></appPersonalizationButton>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
        <appAddToCartButton
          v-show="getAddToCartFullPage || getPersonalizationStatus"
        ></appAddToCartButton>
        <appQuotationButton></appQuotationButton>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
      </div>
    </div>
  </div>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useUploadsStore } from "@/stores/modules/uploads";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, [
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ]),
    ...mapState(useWebproductStore, ["getUploadPersonalizationOneProduct"]),
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"]),
    ...mapState(useUploadsStore, ["getUploadsForPP"])
  }
};
</script>
